export default "__VITE_ASSET__BLd1wMSO__"